import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b1a6615&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0b1a6615&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1a6615",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b1a6615')) {
      api.createRecord('0b1a6615', component.options)
    } else {
      api.reload('0b1a6615', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0b1a6615&scoped=true&", function () {
      api.rerender('0b1a6615', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/case/judge/index.vue"
export default component.exports